<template>
    <div class="gallery-module">
        <div class="filter-row">
            <selectDropdown :options="categories"
                            :background-color="buttons_color"
                            @optionSelected="filterChanged" />
        </div>
        <div class="gallery-row">
            <template v-if="filteredGallery.length">
                <transition-group name="gallery-group" tag="div" id="gallery" class="gallery-list">
                    <div v-for="(image,i) in filteredGallery"
                         :class="['gallery-item', {even: (i + 1) % 2 === 0}]"
                         :key="`gallery-image-${image.id}`">
                        <wp-image :image="image"
                                  :isBackground="true"
                                  class="gallery-image" />
                        <div class="gallery-image-overlay"
                            @click="openLightbox(i)"></div>
                    </div>
                </transition-group>
            </template>
            <div v-else class="none-found-container">
                <div v-if="loading">
                    <p>Loading Gallery</p>
                    <font-awesome-icon :icon="spinner" class="loader" />
                </div>
                <p v-else class="none-found">
                    No Gallery Images Found
                </p>
            </div>
        </div>
        <div class="load-more-row">
            <load-more-button v-if="showLoadMore" @loadMore="loadMore" :background-color="buttons_color" />
        </div>
    </div>
</template>

<script>
    import _slice from 'lodash/slice'
    import _find from 'lodash/find'
    import _filter from 'lodash/filter'
    import SelectDropdown from './components/SelectDropdown'
    import LoadMoreButton from './components/LoadMoreButton'
    import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird'

    export default {
        name: "GalleryModule",
        components: {
            SelectDropdown,
            LoadMoreButton
        },
        props: {
            gallery: Array | Boolean,
            images_per_page: {
                type: String,
                default: '4'
            },
            buttons_color: String,
        },
        data() {
            return {
                page: 1,
                categoryFilter: 'All',
                clickedLoadMore: 1,
                loadedImages: [],
                showLoadMore: true,
                loading: true,
                lightboxOpen: false,
            }
        },
        computed: {
            filteredGallery() {
                if (!this.gallery) return [];

                let filteredGallery = this.gallery;

                if (this.categoryFilter !== 'All') {
                    filteredGallery = _filter(filteredGallery, (image) => {
                        if (image.categories) {
                            return _find(image.categories, ['name', this.categoryFilter])
                        }
                    })
                }

                if (this.totalToShow <= this.gallery.length && !this.lightboxOpen) {
                    filteredGallery = _slice(filteredGallery, 0, this.totalToShow);
                }

                this.showLoadMore = this.gallery.length > this.totalToShow;

                return filteredGallery
            },
            categories() {
                const categories = new Set();
                (this.gallery || []).forEach(image => {
                    (image.categories || []).forEach(category => {
                       categories.add(category.name)
                    });
                });
                categories.add('All');
                return [...categories].sort();
            },
            totalToShow() {
                return this.clickedLoadMore * parseInt(this.images_per_page)
            },
            spinner() {
                return faSpinnerThird
            },
            dynamicGallery() {
                return this.filteredGallery && this.filteredGallery.map(image => {
                    return {
                        src: image.url,
                        thumb: image.sizes.medium,
                        subHtml: image.caption
                    }
                })
            },
        },
        methods: {
            loadMore() {
                this.clickedLoadMore++
            },
            filterChanged(value) {
                this.categoryFilter = value
            },
            openLightbox(i) {
                this.lightboxOpen = true;
                document.body.classList.add('no-scroll');

                if (this.galleryInitialized) {
                    jQuery('#gallery').data('lightGallery').destroy(true)
                }

                this.initLightGallery(i)
            },
            initLightGallery(i) {
                const gallery = jQuery('#gallery');

                gallery.lightGallery({
                    selector: '.gallery-image-container',
                    dynamic: true,
                    dynamicEl: this.dynamicGallery,
                    index: i
                });

                gallery.on('onBeforeClose.lg', () => {
                    document.body.classList.remove('no-scroll');
                    this.lightboxOpen = false
                });
                this.galleryInitialized = true
            },
        },
    }
</script>

<style lang="scss" scoped>

    .gallery-module {
        display: flex;
        flex-direction: column;
        @include site-container;
    }

    .filter-row {
        width: 100%;
        margin: 80px auto 0;
        display: flex;
        max-width: 1240px;
    }

    .gallery-list {
        width: 100%;
        max-width: 1240px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 50px auto;

        .gallery-item {
            overflow: hidden;
            width: calc(50% - 15px);
            height: 362px;
            margin: 20px 0;
            position: relative;
            color: #fff;
            @include box-shadow();

            @media (max-width: 992px){
                height: 300px;
            }
            
            @media (max-width: 767px){
                height: 222px;
            }

            @media (max-width: 650px){
                width: 100%;
                height: calc(100vw / 2);
            }

            &:hover {
                /deep/ .gallery-image{
                    transform: scale(1.1);
                }
            }

            &.even{
                margin-top: 45px;
            }


            .gallery-image-overlay{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
                cursor: pointer;
            }
        }

        /deep/ {
            .gallery-image{
                position: absolute;
                width: 100%;
                height: 100%;
                background-size: cover;
                transition: all .3s ease-in-out;
            }
        }
    }

    .load-more-row {
        /deep/ {
            .link-cta{
                margin: auto;
            }
        }
    }

</style>